// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum MovementType {
	Debit = 1,
	Credit = 2,
}
